var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card class chart"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("分类时长统计")]),_c('div',{staticClass:"filter"},[_c('ul',[_c('li',{staticClass:"active"},[_vm._v("按班级")]),_c('li',[_vm._v("按课程")])])])]),_c('div',{staticClass:"chart",attrs:{"id":"chartClass"}})])
}]

export { render, staticRenderFns }